import { Theme, alpha } from '@mui/material/styles'
import { ColorsTypes } from 'types/types/colors'

export const styledButtonWithIcon = (theme: Theme, color: ColorsTypes) => ({
  borderRadius: '50%',
  ['&:hover']: {
    backgroundColor: alpha(theme.palette[color].main, 0.1)
  }
})
